import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../../../../lib/api';

const formatDate = newDate => {
  if (typeof newDate === 'string') {
    const year = newDate.substr(0, 4);
    const month = parseInt(newDate.substr(5, 2), 10) - 1;
    const day = newDate.substr(8, 2);
    return new Date(year, month, day);
  }
  return newDate;
};

const transformPrizeDescriptions = prizeDescriptions => {
  if (prizeDescriptions.length === 1 && prizeDescriptions[0] === '') {
    return [];
  }

  return prizeDescriptions;
};

const transformPrize = prize => {
  const values = {
    prize: {
      id: prize.id,
      start_date: prize.startDate,
      end_date: prize.endDate,
      message: prize.message,
      prize_descriptions: transformPrizeDescriptions(prize.prizeDescriptions),
      post_id: prize.postId,
    },
  };

  return values;
};

export const useGetPrize = ({ sortBy, sortDirection, campaignUuid }) => {
  const params = {
    sort_by: sortBy,
    sort_direction: sortDirection,
  };

  const { data = { data: {} } } = useQuery(
    ['getPrize', campaignUuid, params],
    () => get(`/api/client_admin/campaigns/${campaignUuid}/prizes`, params),
    {
      keepPreviousData: true,
    },
  );

  const response = data;

  if (response && response.startsAt) {
    response.startsAt = formatDate(response.startsAt);
  }

  if (response && response.endsAt) {
    response.endsAt = formatDate(response.endsAt);
  }

  return response;
};

export const updatePrize = prize => {
  const valuesTransformed = transformPrize(prize);

  return api({
    method: 'put',
    url: `/api/client_admin/campaigns/${prize.campaignUuid}/prizes/${prize.id}`,
    data: valuesTransformed,
  });
};

export const createPrize = prize => {
  const valuesTransformed = transformPrize(prize);

  return api({
    method: 'post',
    url: `/api/client_admin/campaigns/${prize.campaignUuid}/prizes`,
    data: valuesTransformed,
  });
};

export const destroyPrize = prize => {
  const valuesTransformed = transformPrize(prize);

  return api({
    method: 'delete',
    url: `/api/client_admin/campaigns/${prize.campaignUuid}/prizes/${prize.id}`,
    data: valuesTransformed,
  });
};

export const pickWinners = ({ prize, winnersNumber, repick }) => {
  return api({
    method: 'post',
    url: `/api/client_admin/campaigns/${prize.campaignUuid}/prize_winners`,
    data: { number_of_winners: winnersNumber, repick },
  });
};

export const repickWinner = ({ prize, userId }) => {
  return api({
    method: 'put',
    url: `/api/client_admin/campaigns/${prize.campaignUuid}/prize_winners/${userId}`,
  });
};

export const deleteWinner = ({ prize, userId }) => {
  return api.delete(
    `/api/client_admin/campaigns/${prize.campaignUuid}/prize_winners/${userId}`,
  );
};
